export const Styles = () => ({
  col: {
    width: ({ size }) => `${100 / size}%`,
  },
});
